exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".uu5-forms-text-button {\n  margin-top: 0.1em;\n  margin-bottom: 1em;\n}\n.uu5-forms-text-button:after {\n  display: block;\n  position: relative;\n  content: '';\n  clear: both;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/less-loader/dist!./forms/text-button.less
// module id = 333
// module chunks = 0